import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {TooltipModule} from "ngx-tooltip";
import {EnvironmentComponent} from "./EnvironmentComponent";

@NgModule({
    declarations: [EnvironmentComponent],
    exports: [EnvironmentComponent],
    imports: [TooltipModule, BrowserModule]
})
export class EnvironmentComponentModule {
}



// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/Environment/EnvironmentComponentModule.ts